<template>
    <div class='component-page'>
        <!--文本搜索位置-->
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
                <Col span="4">
                    <Input search v-model="formItem.name" placeholder="输入课程名称" @on-search="handleSearch" style="width:100%;" />
                </Col>
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row style='margin-bottom: 20px;'>
                <Col span="10">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
                <Col span="6">
                    <Select v-model="formItem.type_id" placeholder="课程类型" @on-change="handleSearch" clearable style="width:200px">
                        <Option v-for="item in typeList" :value="item.type_id" :key="item.type_id">{{ item.name }}</Option>
                    </Select>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right' size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
        <Modal v-model='editClassModal' width='900' title='编辑课次'>
            <Tree :data="treeData" :render="renderContent" show-checkbox @on-check-change='changeTree'></Tree>
            <div slot="footer">
                <Button type='primary' shape="circle" @click='sync'>同步到学生目录</Button>

                <Button type='primary' ghost shape="circle" @click='cancel'>关闭</Button>
            </div>
        </Modal>
        <Modal v-model="classModel" width="480" title='章节' @on-cancel='cancelChapter'>
            <Form ref="chapterFrom" :model="chapterFrom" label-position="top">
                <FormItem label="章节名称" prop='name' v-if='!chapterLevel'>
                    <Input v-model="chapterFrom.name" type="text" placeholder="请输入..." style="width:260px;"></Input>
                </FormItem>
                <Row style='margin-top:10px' v-if="(!chapterLevel&&(modelLabel=='添加'&&appendData.level==0)&&lessonType=='体验课')||(!chapterLevel&&(modelLabel=='修改'&&appendData.level==1)&&lessonType=='体验课')">
                    <FormItem label="目录类型" prop='name' v-if='!chapterLevel'>
                        <Select v-model="chapterFrom.directory_type" placeholder="请选择" clearable style="width:120px">
                            <Option v-for="item in directoryList" :value="item.id" :key="item.province_id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                </Row>
                <FormItem label="章节类型" prop='type' v-if='chapterLevel'>
                    <Radio-group v-model="chapterFrom.type">
                        <Radio label="1">组图</Radio>
                        <Radio label="2">视频</Radio>
                        <Radio label="3">组图+音频</Radio>
                        <Radio label="4">音符识键</Radio>
                        <Radio label="5">画音符</Radio>
                        <Radio label="6">测试题</Radio>
                    </Radio-group>
                </FormItem>
                <FormItem label="图片" prop='images' v-if='chapterFrom.type==1||chapterFrom.type==3&&chapterLevel'>
                    <dragImg v-if='classModel' @getPicList="getChapterImgList" :getList='chapterFrom.images' message='100' id='images'></dragImg>
                </FormItem>
                <Row v-if='chapterFrom.type==5&&chapterLevel'>   
                    <FormItem label="图片" prop='images'>
                        <dragImg v-if='classModel' @getPicList="getBgImg" :getList='chapterFrom.drawing_note.bg_img' message='100' id='bg_img'></dragImg>
                    </FormItem>
                    <FormItem label="gif" prop='images'>
                        <UploadGif v-if='classModel' @getPicList="getChapterImgList" :getList='chapterFrom.drawing_note.gif' message='100' id='gif'></UploadGif>
                    </FormItem>
                </Row>
                <FormItem label="视频" prop='source_url' v-if='chapterFrom.type==2&&chapterLevel'>
                    <UploadVideo @getVideos="getVideos" :getVideourl='chapterFrom.source_url' message='1'></UploadVideo>
                </FormItem>
                <FormItem label="音频" prop='source_url' v-if='chapterFrom.type==3&&chapterLevel'>
                    <Audio @getAudioList="getAudioList" :getList='chapterFrom.source_url' message='1'></Audio>
                </FormItem>
                <Row style='margin-top:10px' v-if='chapterFrom.type==4&&chapterLevel'>
                    <div v-if='chapterFrom.type==4&&chapterFrom.note_key.length>0' v-for='(item,index) in chapterFrom.note_key'>
                        <img :src="'https://storage.art-kangaroo.com'+item.bg_img" alt="" style='height:100px;margin-right:16px'>
                        <img :src="'https://storage.art-kangaroo.com'+item.bt_img" alt="" style='height:100px;margin-right:16px'>
                        <img :src="'https://storage.art-kangaroo.com'+item.gif" alt="" style='height:100px'>
                        <audio :src="'https://storage.art-kangaroo.com'+item.mp3" controls="controls" style='width:80%;margin-top:12px;'></audio>
        
                        <Button type='primary' @click='editNote(item,index)' style='margin-bottom:70px;position: relative; bottom: 40px;'>修改改组</Button>
        
                    </div>
                    <Button type="default" @click='addNote'> 
                        <div style="width: 28px;height:28px;line-height: 33px;">
                            <Icon type="md-add" size="20"></Icon>
                        </div>
                    </Button>
                </Row>
                <Row style='margin-top:10px' v-if='chapterFrom.type==6&&chapterLevel'>
                背景图：
                    <UploadImg v-if="classModel" @getPicList="getBg" :getList='chapterFrom.question.background' message='1' id='background'></UploadImg>
    
                    <div v-if='chapterFrom.type==6&&chapterFrom.question.question_list.length>0' v-for='(item,index) in chapterFrom.question.question_list' style='margin:10px 0'>
                        <div v-if='item.type==1' class='list-p'>
                            结果：
                            <img v-for='list in materialList' v-if="item.detail[0]==list.id" :src="'https://storage.art-kangaroo.com'+list.image_url"> = 素材：
                            <img v-for='list in materialList' v-if="item.detail[1]==list.id" :src="'https://storage.art-kangaroo.com'+list.image_url"> + 正确答案：
                            <div v-for='question in item.answer' style='display: inline-block;'>
                                <img class='answerList' v-for='list in questionList' v-if='question==list.id' :src="'https://storage.art-kangaroo.com'+list.image_url">
                            </div>
    
                        </div>
                        <div v-if='item.type==2' class='list-p'>
                            结果：
                            <img v-for='list in materialList' v-if="item.detail[0]==list.id" :src="'https://storage.art-kangaroo.com'+list.image_url"> = 素材：
                            <img v-for='list in materialList' v-if="item.detail[1]==list.id" :src="'https://storage.art-kangaroo.com'+list.image_url"> + 素材：
                            <img v-for='list in materialList' v-if="item.detail[2]==list.id" :src="'https://storage.art-kangaroo.com'+list.image_url"> + 正确答案：
                            <div v-for='question in item.answer' style='display: inline-block;'>
                                <img class='answerList' v-for='list in questionList' v-if='question==list.id' :src="'https://storage.art-kangaroo.com'+list.image_url">
                            </div>
        
                        </div>
                        <div v-if='item.type==3' class='list-p'>
                            结果：
                            <img v-for='list in materialList' v-if="item.detail[0]==list.id" :src="'https://storage.art-kangaroo.com'+list.image_url"> = 素材：
                            <img v-for='list in materialList' v-if="item.detail[1]==list.id" :src="'https://storage.art-kangaroo.com'+list.image_url"> + 素材：
                            <img v-for='list in materialList' v-if="item.detail[2]==list.id" :src="'https://storage.art-kangaroo.com'+list.image_url"> + 正确答案：
                            <div v-for='question in item.answer' style='display: inline-block;'>
                                <img class='answerList' v-for='list in questionList' v-if='question==list.id' :src="'https://storage.art-kangaroo.com'+list.image_url">
                            </div>
                            + 素材：
        
                            <img v-for='list in materialList' v-if="item.detail[4]==list.id" :src="'https://storage.art-kangaroo.com'+list.image_url">
        
                        </div>
                    </div>
                    <div style='margin:18px 0px'>
                        测试题：
                        <Button @click='addSubject'> 
                            <div style="width: 28px;height:28px;line-height: 33px;">
                                <Icon type="md-add" size="20"></Icon>
                            </div>
                        </Button>
                    </div>
    
                </Row>
            </Form>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelChapter'>取消</Button>
                <Button type="primary" shape="circle"  @click="okChapter">保存</Button>
            </div>
        </Modal>
        <Modal v-model="noteModal" :mask-closable='false' width="550" :title='noteTitle' @on-cancel='cancelNote'>
            <Note v-if='noteModal' @getNote="getNoteLists" :noteState='noteModal' :getNoteList='noteLists'></Note>
            <div slot="footer">
                <Button type='primary' ghost @click='cancelNote'>取消</Button>
                <Button type="primary" @click="okNote">保存</Button>
            </div>
        </Modal>
        <Modal v-model="subjectModel" :mask-closable='false' width="600" title='素材' @on-cancel='cancelSubject'>
            <Row style='margin-top:10px' v-if='chapterFrom.type==6&&chapterLevel'>
                <span>题型：</span>
                <Radio-group v-model="questionObj.type">
                    <Radio label="1">题型1</Radio>
                    <Radio label="2">题型2</Radio>
                    <Radio label="3">题型3</Radio>
                </Radio-group>
            </Row>
            <div style='font-size:14px;margin-top:10px;'>
                <div v-if='questionObj.type==1'>
                    结果：
                    <Button v-if="!titleList[0]||titleList[0]==''" style='padding: 12px 17px;font-size: 16px;'  icon='md-add' @click="addQuestion('结果')"></Button>
                    <div class='list'>
                        <img v-if="(!!titleList[0])&&titleList[0]!=''" :src="'https://storage.art-kangaroo.com'+titleList[0]">
                        <div class="list-cover" @click="deleteTitle(0,'结果')">
                            <Icon type="ios-trash" style='color:#ddd;font-size: 20px;margin: 15px 10px;'></Icon>
                        </div>
                    </div>
                    = 素材：
                    <Button v-if="!titleList[1]||titleList[1]==''" style='padding: 12px 17px;font-size: 16px;'  icon='md-add' @click="addQuestion('素材1')"></Button>
                    <div class='list'>
                        <img v-if="(!!titleList[1])&&titleList[1]!=''" :src="'https://storage.art-kangaroo.com'+titleList[1]">
                        <div class="list-cover" @click="deleteTitle(1,'素材1')">
                            <Icon type="ios-trash" style='color:#ddd;font-size: 20px;margin: 15px 10px;'></Icon>
                        </div>
                    </div>
                    + 正确答案：
                    <Button v-if='answerList.length==0' style='padding: 12px 17px;font-size: 16px;'  icon='md-add' @click="addQuestion('答案')"></Button>
                    <img class='answerList' v-if='answerList.length!=0' v-for='item in answerList' @click="editAnswer('答案')" :src="'https://storage.art-kangaroo.com'+item.url">
                </div>
                <div v-if='questionObj.type==2'>
                    结果：
                    <Button v-if="!titleList[0]||titleList[0]==''" style='padding: 12px 17px;font-size: 16px;'  icon='md-add' @click="addQuestion('结果')"></Button>
                    <div class='list'>
                        <img v-if="(!!titleList[0])&&titleList[0]!=''" :src="'https://storage.art-kangaroo.com'+titleList[0]">
                        <div class="list-cover" @click="deleteTitle(0,'结果')">
                            <Icon type="ios-trash" style='color:#ddd;font-size: 20px;margin: 15px 10px;'></Icon>
                        </div>
                    </div>
                    = 素材：
                    <Button v-if="!titleList[1]||titleList[1]==''" style='padding: 12px 17px;font-size: 16px;'  icon='md-add' @click="addQuestion('素材1')"></Button>
                    <div class='list'>
                        <img v-if="(!!titleList[1])&&titleList[1]!=''" :src="'https://storage.art-kangaroo.com'+titleList[1]">
                        <div class="list-cover" @click="deleteTitle(1,'素材1')">
                            <Icon type="ios-trash" style='color:#ddd;font-size: 20px;margin: 15px 10px;'></Icon>
                        </div>
                    </div>
                    + 素材：
                    <Button v-if="!titleList[2]||titleList[2]==''" style='padding: 12px 17px;font-size: 16px;'  icon='md-add' @click="addQuestion('素材2')"></Button>
                    <div class='list'>
                        <img v-if="(!!titleList[2])&&titleList[2]!=''" :src="'https://storage.art-kangaroo.com'+titleList[2]">
                        <div class="list-cover" @click="deleteTitle(2,'素材2')">
                            <Icon type="ios-trash" style='color:#ddd;font-size: 20px;margin: 15px 10px;'></Icon>
                        </div>
                    </div>
                    + 正确答案：
                    <Button v-if='answerList.length==0' style='padding: 12px 17px;font-size: 16px;'  icon='md-add' @click="addQuestion('答案')"></Button>
                    <img class='answerList' v-if='answerList.length!=0' v-for='item in answerList' @click="editAnswer('答案')" :src="'https://storage.art-kangaroo.com'+item.url">
                </div>
                <div v-if='questionObj.type==3'>
                    结果：
                    <Button v-if="!titleList[0]||titleList[0]==''" style='padding: 12px 17px;font-size: 16px;'  icon='md-add' @click="addQuestion('结果')"></Button>
                    <div class='list'>
                        <img v-if="(!!titleList[0])&&titleList[0]!=''" :src="'https://storage.art-kangaroo.com'+titleList[0]">
                        <div class="list-cover" @click="deleteTitle(0,'结果')">
                            <Icon type="ios-trash" style='color:#ddd;font-size: 20px;margin: 15px 10px;'></Icon>
                        </div>
                    </div>
                    = 素材：
                    <Button v-if="!titleList[1]||titleList[1]==''" style='padding: 12px 17px;font-size: 16px;'  icon='md-add' @click="addQuestion('素材1')"></Button>
                    <div class='list'>
                        <img v-if="(!!titleList[1])&&titleList[1]!=''" :src="'https://storage.art-kangaroo.com'+titleList[1]">
                        <div class="list-cover" @click="deleteTitle(1,'素材1')">
                            <Icon type="ios-trash" style='color:#ddd;font-size: 20px;margin: 15px 10px;'></Icon>
                        </div>
                    </div>
                    + 素材：
                    <Button v-if="!titleList[2]||titleList[2]==''" style='padding: 12px 17px;font-size: 16px;'  icon='md-add' @click="addQuestion('素材2')"></Button>
                    <div class='list'>
                        <img v-if="(!!titleList[2])&&titleList[2]!=''" :src="'https://storage.art-kangaroo.com'+titleList[2]">
                        <div class="list-cover" @click="deleteTitle(2,'素材2')">
                            <Icon type="ios-trash" style='color:#ddd;font-size: 20px;margin: 15px 10px;'></Icon>
                        </div>
                    </div>
                    + 正确答案：
                    <Button v-if='answerList.length==0' style='padding: 12px 17px;font-size: 16px;'  icon='md-add' @click="addQuestion('答案')"></Button>
                    <img class='answerList' v-if='answerList.length!=0' v-for='item in answerList' @click="editAnswer('答案')" :src="'https://storage.art-kangaroo.com'+item.url"> + 素材：
                    <Button v-if="!titleList[3]||titleList[3]==''" style='padding: 12px 17px;font-size: 16px;'  icon='md-add' @click="addQuestion('素材3')"></Button>
                    <div class='list'>
                        <img v-if="(!!titleList[3])&&titleList[3]!=''" :src="'https://storage.art-kangaroo.com'+titleList[3]">
                        <div class="list-cover" @click="deleteTitle(3,'素材3')">
                            <Icon type="ios-trash" style='color:#ddd;font-size: 20px;margin: 15px 10px;'></Icon>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <Button type='primary' ghost @click='cancelSubject'>取消</Button>
                <Button type="primary" @click="okSubject">保存</Button>
            </div>
        </Modal>
        <Modal v-model="cdrModel" :mask-closable='false' width="600" title='素材' @on-cancel='cancelCdr'>
            <div class='img-box' v-if="questionLabel!='答案'">
                <img v-for='(item,index) in materialList' @click='selectCdr(index,item.id,item.image_url)' :class="item.isSelect?'active':''" :src="'https://storage.art-kangaroo.com'+item.image_url" style='border:1px solid #000;padding:10px;margin-left:10px;height:100px;cursor: pointer;'>
            </div>
            <div class='img-box' v-if="questionLabel=='答案'">
                <img v-for='(item,index) in questionList' @click='selectCdr(index,item.id,item.image_url)' :class="item.isSelect?'active':''" :src="'https://storage.art-kangaroo.com'+item.image_url" style='border:1px solid #000;padding:10px;margin-left:10px;height:100px;cursor: pointer;'>
            </div>
    
            <div slot="footer">
    
                <Button type="primary" @click="okCdr">确定</Button>
            </div>
        </Modal>
        <Modal v-model="questionModel" :mask-closable='false' width="600" title='素材' @on-cancel='cancelQuestion'>
            <UploadImg v-if="questionModel" @getPicList="getQuestionList" :getList='questionImg' message='20' id='questionImg'></UploadImg>

            <div slot="footer">
                <Button type='primary' ghost @click='cancelQuestion'>取消</Button>
                <Button type="primary" @click="okQuestion">确定</Button>
            </div>
        </Modal>
         <Modal v-model="lessonContentModel" width="400" title='查看' @on-cancel='cancelLessonContent'>
            <Carousel v-model="carouselVal" loop v-if='lessonContentType==1||lessonContentType==3&&lessonContentModel'>
                <CarouselItem v-for='item in imgContent' style='text-align:center' :key='item'>
                    <img :src='item' width="100%"></img>
                </CarouselItem>
            </Carousel>
            <video v-else-if="lessonContentType==2&&lessonContentModel" :src='lessonContentVideo' controls="controls" autoplay="autoplay" style='margin:0 auto;width:60%;display:block'>
                    <source :src='lessonContentVideo' type="video/mp4">
                    <source :src='lessonContentVideo' type="video/mov">
                </video>
            <audio v-if="lessonContentType==3&&lessonContentModel" :src="audioUrl" autoplay controls="controls"></audio>
        </Modal>
        <!--提醒弹层-->
        <Modal v-model="remindModal" width="440" class='remind'>
            <div class='remindContent'>
                {{remindContent}}
            </div>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemain'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
    
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<style>
    .img-box .active {
        border: 1px solid red!important;
    }
    
    .list-cover {
        cursor: pointer;
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.4);
        width: 100%;
    }
    
    .list {
        display: inline-block;
        vertical-align: middle;
        position: relative;
    }
    
    .list img {
        cursor: pointer;
        border: 1px solid;
        padding: 10px;
        height: 50px;
        display: block;
    }
    
    .list-p img {
        cursor: pointer;
        border: 1px solid;
        padding: 10px;
        height: 50px;
        vertical-align: middle;
    }
    
    .answerList {
        cursor: pointer;
        border: 1px solid;
        padding: 10px;
        height: 50px;
        vertical-align: middle;
        margin-right: 10px;
    }
    
    .list:hover .list-cover {
        display: block;
    }
</style>
<script>
    import {
        fetchTableList,
        fetchChapterInfo,
        setDel,
        modifySave,
        addSave,
        setSort,
        setSync,
        fetchDirectory,
        fetchMaterialList,
        upMaterial
    } from '@/api/studentCourseCatalogue'
    import {
        fetchLessonTypeList,
    } from '@/api/common'
    
    import UploadImg from '../common/picture.vue'
    import UploadVideo from '../common/videos.vue'
    import dragImg from '../common/drag-img.vue'

    import Audio from '../common/audio.vue'
    import UploadGif from '../common/picturegif.vue'
    import Note from '../common/note.vue'


    
    export default {
        name: 'user-components',
        components: {
            UploadImg,
            dragImg,
            UploadVideo,
            Audio,
            UploadGif,
            Note
        },
        data() {
            return {
                modelLabel:'',
                lessonType:'',
                directoryList:[],
                total_count: 0, //列表总条数
                carouselVal: 0, //跑马灯索引
                imgContent: [], //跑马灯图片
                noteModal: false, //上传音符识键的弹层
                subjectModel: false, //添加测试题的弹层
                audioUrl: '',
                noteIndex: '', //音符识键下标
                questionImg: [], //答案素材图片
                questionList: [], //答案素材列表
                answerList: [], //选择的答案素材

                cdrModel: false, //素材的弹层
                questionLabel: '', //题的标签，答案，素材，结果
                questionModel: false, //上传答案素材的弹层
                materialList: [], //素材列表
                titleList: [],
                lessonId: '', //课程id

                noteTitle: '添加音符识键',

                formItem: {
                    page: 1, //列表当前页数
                    page_size: 10,
                    name: '',
                    start_time: '',
                    end_time: '',
                    type_id:'',
                },
                noteLists: {
                    bg_img: '',
                    bt_img: '',
                    gif: '',
                    mp3: '',
                },
                questionObj: {
                    type: '', //题型
                    detail: [],
                    answer: [],
                },
                chapter_id_arr:[],
                appendData:'',
                editorData:'',
                start_time: '',
                end_time: '',
                chapter_id:'',
                typeList: [],
                
                defaultMsg: '',
                config: {
                    initialFrameWidth: null,
                    initialFrameHeight: 350
                },
                chapterLevel: false,
                lessonContentModel:false,
                lessonContentType: '', //课程内容类型
                lessonContentVideo: '', //课程内容视频地址

                editClassModal: false, //树状图弹出层状态
                classModel: false, //添加课次弹出层状态
                chapterFrom: {
                    lesson_id:'',
                    parent_id:'',
                    name:'',
                    type:'',
                    directory_type:'',
                    chapter_id: '',

                    images:'',
                    source_url:'',
                    note_key: [],
                     drawing_note: {
                        bg_img: '',
                        gif: '',
                    },
                    question: {
                        background: '',
                        answer_material: [],
                        question_list: [],
                    }
                },
                chapterLevel: false, //是否添加第三层章节
                remindContent: '', //提醒内容
                remindModal: false, //提醒弹层状态
                treeData: [{
                    title: '课次',
                    level: '0',
                    id: 0,
                    parent_id: 0,
                    chapter_id: 0,
                    expand: true,
                    children: [],
                    render: (h, {
                        root,
                        node,
                        data
                    }) => {
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%'
                            }
                        }, [
                            h('span', [
                                h('Icon', {
                                    props: {
                                        type: 'ios-folder-outline'
                                    },
                                    style: {
                                        marginRight: '8px'
                                    }
                                }),
                                h('span', data.title)
                            ]),
                            h('span', {
                                style: {
                                    display: 'inline-block',
                                    float: 'right',
                                    marginRight: '32px'
                                }
                            }, [
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        icon: 'md-add',
                                        type: 'primary'
                                    }),
                                    style: {
                                        width: '124px'
                                    },
                                    on: {
                                        click: () => {
                                            this.append(data)
                                        }
                                    }
                                }, '添加课次')
                            ])
                        ]);
                    }
                }],
                upProps: {
                    type: 'info',
                    size: 'small',
                    ghost: true

                },
                downProps: {
                    type: 'info',
                    size: 'small',
                    ghost: true

                },
                appendProps: {
                    type: 'primary',
                    size: 'small',
                    ghost: true
                },
                removeProps: {
                    type: 'error',
                    size: 'small',
                    ghost: true
                },
                editIncellColumns: [{
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
    
                    {
                        title: '课程名称',
                        align: 'center',
                        key: 'name',
    
                    },
                    {
                        title: '课程类型',
                        align: 'center',
                        key: 'type_name',
                    },
    
                    {
                        title: '状态',
                        align: 'center',
                        key: 'status',
                        render: (h, params) => {
                            if(params.row.status==1){
                                return h('div', '上架')

                            }else{
                                return h('div', '下架')

                            }
                        }

                    },
    
                    {
                        title: '上架时间',
                        align: 'center',
                        key: 'publish_at',
                        width: 150,
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 160,
                        render: (h, params) => {
    
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                        ghost: true
    
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.editChapter(params.row.lesson_id)
                                        }
                                    }
                                }, '编辑课次'),
    
                            ])
                        }
                    }
    
                ], //列表
                editIncellData: [], //列表数据
            };
        },
        methods: {
            //获取列表数据
            getData() {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res = res.data;
                    this.$Loading.finish();
                    if (res.code == 200) {
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            getLessonTypeList(){
                fetchLessonTypeList().then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.typeList = res.data;
                    
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
             // 选择素材
            selectCdr(i, id, url) {
                var _this = this;
    
                if (this.questionLabel == '答案') {
                    this.questionList.forEach(function(item, index) {
                        if (index == i) {
                            item.isSelect = !item.isSelect;
                            if (item.isSelect) {
                                _this.questionObj.answer.push(id);
                                _this.answerList.push({
                                    'id': id,
                                    'url': url
                                });
                            } else {
                                _this.answerList.forEach(function(list, j) {
                                    if (list.url == url) {
                                        _this.answerList.splice(j, 1)
                                        _this.questionObj.answer.splice(j, 1)
                                    }
                                })
    
    
                            }
                        }
                    })
                } else {
                    this.materialList.forEach(function(item, index) {
                        if (index == i) {
                            item.isSelect = !item.isSelect;
                            if (item.isSelect) {
                                if (_this.questionObj.type == 1) {
                                    if (_this.questionLabel == '结果') {
                                        _this.questionObj.detail[0] = id,
                                            _this.titleList[0] = url;
                                    } else if (_this.questionLabel == '素材1') {
                                        _this.questionObj.detail[1] = id;
                                        _this.titleList[1] = url;
                                    }
                                    _this.questionObj.detail[2] = '-1'
    
                                } else if (_this.questionObj.type == 2) {
                                    if (_this.questionLabel == '结果') {
                                        _this.questionObj.detail[0] = id;
                                        _this.titleList[0] = url;
                                    } else if (_this.questionLabel == '素材1') {
                                        _this.questionObj.detail[1] = id;
                                        _this.titleList[1] = url;
                                    } else if (_this.questionLabel == '素材2') {
                                        _this.questionObj.detail[2] = id;
                                        _this.titleList[2] = url;
                                    }
                                    _this.questionObj.detail[3] = '-1'
    
                                } else if (_this.questionObj.type == 3) {
                                    if (_this.questionLabel == '结果') {
                                        _this.questionObj.detail[0] = id;
                                        _this.titleList[0] = url;
    
                                    } else if (_this.questionLabel == '素材1') {
                                        _this.questionObj.detail[1] = id;
                                        _this.titleList[1] = url;
    
                                    } else if (_this.questionLabel == '素材2') {
                                        _this.questionObj.detail[2] = id;
                                        _this.titleList[2] = url;
    
                                    } else if (_this.questionLabel == '素材3') {
                                        _this.questionObj.detail[4] = id;
                                        _this.titleList[3] = url;
    
                                    }
                                    _this.questionObj.detail[3] = '-1'
    
                                };
                            } else {
                                if (_this.questionObj.type == 1) {
                                    if (_this.questionLabel == '结果') {
                                        _this.questionObj.detail[0] = '',
                                            _this.titleList[0] = '';
                                    } else if (_this.questionLabel == '素材1') {
                                        _this.questionObj.detail[1] = '';
                                        _this.titleList[1] = '';
                                    }
                                    _this.questionObj.detail[2] = '-1'
    
                                } else if (_this.questionObj.type == 2) {
                                    if (_this.questionLabel == '结果') {
                                        _this.questionObj.detail[0] = '';
                                        _this.titleList[0] = '';
                                    } else if (_this.questionLabel == '素材1') {
                                        _this.questionObj.detail[1] = '';
                                        _this.titleList[1] = '';
                                    } else if (_this.questionLabel == '素材2') {
                                        _this.questionObj.detail[2] = '';
                                        _this.titleList[2] = '';
                                    }
                                    _this.questionObj.detail[3] = '-1'
    
                                } else if (_this.questionObj.type == 3) {
                                    if (_this.questionLabel == '结果') {
                                        _this.questionObj.detail[0] = '';
                                        _this.titleList[0] = '';
    
                                    } else if (_this.questionLabel == '素材1') {
                                        _this.questionObj.detail[1] = '';
                                        _this.titleList[1] = '';
    
                                    } else if (_this.questionLabel == '素材2') {
                                        _this.questionObj.detail[2] = '';
                                        _this.titleList[2] = '';
    
                                    } else if (_this.questionLabel == '素材3') {
                                        _this.questionObj.detail[4] = '';
                                        _this.titleList[3] = '';
    
                                    }
                                    _this.questionObj.detail[3] = '-1'
    
                                };
                            }
    
                        } else {
                            item.isSelect = false;
    
                        }
                    })
                }
    
            },
            // 确定选择素材
            okCdr() {
                this.cdrModel = false;
                this.getMaterialList();
            },
            // 删除素材
            deleteTitle(index, label) {
                this.questionLabel = label;
                this.titleList[index] = '';
                this.cdrModel = true;
            },
            // 取消选择素材
            cancelCdr() {
                if (this.oldAnswerList.length != 0) {
                    this.answerList = this.oldAnswerList;
                    this.questionList = this.oldQuestionList;
                    this.questionObj.answer = this.oldAnswer;
                } else {
                    this.answerList = this.oldAnswerList;
                    this.questionObj.answer = this.oldAnswer;
                }
    
                this.cdrModel = false;
                this.getMaterialList();
    
            },
            // 获取素材列表
            getMaterialList() {
                fetchMaterialList().then(res => {
                        res = res.data;
                        if (res.code == 200) {
                            res.data.forEach(function(item) {
                                item.isSelect = false;
                            })
                            this.materialList = res.data
                        } else if (res.code == 14004) {
                            this.$store.commit('logout', this);
                            this.$store.commit('clearOpenedSubmenu');
                            this.$router.push({
                                name: 'login'
                            });
                            this.$Message.error(res.msg);
                        } else {
                            this.$Message.error(res.msg);
                        }
                    })
            },
            // 确定上传答案素材
            okQuestion() {

               upMaterial({
                    images: this.questionImg
               }).then(responese => {
                   responese=responese.data;
                        if (responese.code == 200) {
                            var _this = this;
                            responese.data.forEach(function(item) {
                                item.isSelect = false;
                                _this.chapterFrom.question.answer_material.push(item.id)
                            })
                            this.questionList = responese.data;
                            this.questionModel = false;
                            this.cdrModel = true;
                        } else if (responese.code == 14004) {
                            this.$store.commit('logout', this);
                            this.$store.commit('clearOpenedSubmenu');
                            this.$router.push({
                                name: 'login'
                            });
                            this.$Message.error(responese.msg);
                        } else {
                            this.$Message.error(responese.msg);
                        }
                    })
            },
            // 取消上传答案素材
            cancelQuestion() {
                this.questionModel = false;
            },
            // 添加问题
            addQuestion(label) {
    
                this.questionLabel = label;
                this.oldAnswerList = this.answerList.slice(0);
                this.oldAnswer = this.questionObj.answer.slice(0);
                this.oldQuestionList = this.questionList.slice(0);
    
                if (label == '答案' && this.questionList.length == 0) {
                    this.questionObj.answer = [];
                    this.questionModel = true;
                } else {
    
                    this.cdrModel = true;
                }
    
            },
            // 修改答案
            editAnswer(label) {
                this.questionLabel = label;
                this.oldAnswerList = this.answerList.slice(0);
                this.oldQuestionList = this.questionList.slice(0);
                this.oldAnswer = this.questionObj.answer.slice(0);
                this.cdrModel = true;
            },
            // 添加测试题，modal显示
            addSubject() {
                this.subjectModel = true;
            },
            // 取消添加测试题
            cancelSubject() {
                this.questionObj.type = '';
                this.questionObj.detail = [];
                this.questionObj.answer = [];
                this.answerList = [];
                this.titleList = [];
                this.questionList.forEach(function(item, index) {
                    item.isSelect = false;
                });
                this.subjectModel = false;
            },
            // 确定添加测试题
            okSubject() {
                var obj = JSON.parse(JSON.stringify(this.questionObj))
                this.chapterFrom.question.question_list.push(obj);
                this.questionObj.type = '';
                this.questionObj.detail = [];
                this.questionObj.answer = [];
                this.answerList = [];
                this.titleList = [];
                this.questionList.forEach(function(item, index) {
                    item.isSelect = false;
                })
                this.subjectModel = false;
            },
            // 添加章节
            append(data) {
               
                console.log(1)
                this.modelLabel='添加';

                if (data.level == 3) {
                    this.chapterLevel = true;
                } else {
                    this.chapterLevel = false;
                }
                console.log(2)

                this.appendData = data;
                this.chapterFrom.name = '';
                this.chapterFrom.chapter_id = '';
                this.chapterFrom.type = '';
                this.chapterFrom.source_url = '';
                this.chapterFrom.directory_type = '';
                this.chapterFrom.images = [];
                this.chapterFrom.note_key = [];
                this.chapterFrom.drawing_note = {
                    'bg_img': '',
                    'gif': '',
                };
                this.chapterFrom.question.background = '';
                this.chapterFrom.question.answer_material = [];
                this.chapterFrom.question.question_list = [];
                this.questionObj.type = '';
                this.chapterFrom.parent_id = data.chapter_id;
                console.log(3)

                this.classModel = true;
            },
             // 查看课次内容
            lookContent(data, index) {
                
                this.lessonContentModel = true;
                this.lessonContentType = data.type;
                if (index + 1) {
                    this.carouselVal = index;
                    if (data.type == 1 || data.type == 3) {
                        this.imgContent = [];
                        data.images.forEach((item) => {
                            this.imgContent.push('https://storage.art-kangaroo.com' + item)
                        })
                        if (data.type == 3) {
                            this.audioUrl = 'https://storage.art-kangaroo.com' + data.source_url;
    
                        }
                    } else if (data.type == 2) {
                        this.lessonContentVideo = 'https://storage.art-kangaroo.com' + data.source_url;
                    }
                } else {
                    this.carouselVal = 0;
                    if (data.type == 1 || data.type == 3) {
                        this.imgContent = [];
                        data.images.forEach((item) => {
                            this.imgContent.push('https://storage.art-kangaroo.com' + item);
                        })
                        if (data.type == 3) {
                            this.audioUrl = 'https://storage.art-kangaroo.com' + data.source_url;
    
                        }
                    } else if (data.type == 2) {
                        this.lessonContentVideo = 'https://storage.art-kangaroo.com' + data.source_url;
                    }
                }
            },
            // 添加音符识键
            addNote() {
                this.noteLists.bg_img = '';
                this.noteLists.bt_img = '';
                this.noteLists.gif = '';
                this.noteLists.mp3 = '';
                this.noteTitle = '添加音符识键'
                this.noteModal = true;
            },
             // 修改单一一组音符识键
            editNote(obj, index) {
                this.noteTitle = '修改音符识键'
                this.noteIndex = index;
                this.noteLists.bg_img = obj.bg_img;
                this.noteLists.bt_img = obj.bt_img;
                this.noteLists.gif = obj.gif;
                this.noteLists.mp3 = obj.mp3;
                this.noteModal = true;
            },
            // 取消添加音符识键
            cancelNote() {
                this.noteLists.bg_img = '';
                this.noteLists.bt_img = '';
                this.noteLists.gif = '';
                this.noteLists.mp3 = '';
                this.noteModal = false;
                this.noteState = false;
            },
             // 确定上传音符识键
            okNote() {
                if (this.noteLists.bg_img == '') {
                    this.$Message.error('请上传背景图');
                } else if (this.noteLists.bt_img == '') {
                    this.$Message.error('请上传按钮图');
    
                } else if (this.noteLists.gif == '') {
                    this.$Message.error('请上传gif图');
    
                } else if (this.noteLists.mp3 == '') {
                    this.$Message.error('请上传音频');
                } else {
    
                    var obj = JSON.parse(JSON.stringify(this.noteLists))
                    if (this.noteTitle == '修改音符识键') {
                        var index = parseInt(this.noteIndex);
                        this.chapterFrom.note_key[index].bg_img = obj.bg_img;
                        this.chapterFrom.note_key[index].bt_img = obj.bt_img;
                        this.chapterFrom.note_key[index].gif = obj.gif;
                        this.chapterFrom.note_key[index].mp3 = obj.mp3;
                    } else {
                        this.chapterFrom.note_key.push(obj);
                    }
                    this.noteModal = false;
                }
            },
            getNoteLists(list) {
                this.noteLists.bg_img = list.bg_img;
                this.noteLists.bt_img = list.bt_img;
                this.noteLists.gif = list.gif;
                this.noteLists.mp3 = list.mp3;
    
            },
            // 同步学生目录
            sync(){
                setSync({
                    lesson_id:this.lessonId,
                    chapter_id:this.chapter_id_arr
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.$Message.success('同步成功')
                    }else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            // 编辑课次
            editChapter(id) {
                if(id==1){
                    this.lessonType='体验课';

                }else{
                    this.lessonType='';
                }
                this.chapterFrom.lesson_id = id;
                this.lessonId = id;
                fetchChapterInfo({
                    lesson_id: id,
                    member_type:2
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                            var _this=this;
                            var resData = res.data;
                            var arr = [];
                            if (!resData.length) {
                                var arr = [];
                            } else {
                                resData.forEach(function(lesson) {
                                    var obj = {};
                                    obj.title = lesson.name;
                                    obj.chapter_id = lesson.chapter_id;
                                    obj.lesson_id = lesson.lesson_id;
                                    obj.parent_id = lesson.parent_id;
                                    obj.level = lesson.level;
                                    if(_this.lessonType=='体验课'){
                                        obj.directory_type = lesson.directory_type;
                                    }
                                    // obj.expand = true;
                                    obj.children = [];
                                    // if(lesson.children.length!=0){
                                    lesson.children.forEach(function(block) {
                                        var moduleObj = {};
                                        moduleObj.title = block.name;
                                        moduleObj.lesson_id = block.lesson_id;
                                        moduleObj.parent_id = block.parent_id;
                                        moduleObj.chapter_id = block.chapter_id;
                                        moduleObj.level = block.level;
                                        moduleObj.expand = true;
                                        moduleObj.children = [];
                                        obj.children.push(moduleObj)
                                        // if(block.children.length!=0){
                                        block.children.forEach(function(link) {
                                            var linkObj = {};
                                            linkObj.title = link.name;
                                            linkObj.lesson_id = link.lesson_id;
                                            linkObj.chapter_id = link.chapter_id;
                                            linkObj.parent_id = link.parent_id;
                                            linkObj.level = link.level;
                                            linkObj.expand = true;
                                            linkObj.children = [];
                                            moduleObj.children.push(linkObj)
                                            link.children.forEach(function(item) {
                                                var itemObj = {};
                                                if (item.type == 1) {
                                                    itemObj.title = '图片类：';
                                                } else if (item.type == 2) {
                                                    itemObj.title = '视频类：';
    
                                                } else if (item.type == 3) {
                                                    itemObj.title = '组图+音频类：';
                                                } else if (item.type == 4) {
                                                    itemObj.title = '音符识键：';
                                                } else if (item.type == 5) {
                                                    itemObj.title = '画音符：';
                                                } else if (item.type == 6) {
                                                    itemObj.title = '测试题：';
                                                }
                                                itemObj.lesson_id = item.lesson_id;
                                                itemObj.chapter_id = item.chapter_id;
                                                itemObj.parent_id = item.parent_id;
                                                itemObj.type = item.type;
                                                itemObj.level = item.level;
                                                itemObj.images = item.images;
                                                itemObj.source_url = item.source_url;
                                                itemObj.drawing_note = item.drawing_note;
                                                itemObj.question = item.question;
                                                itemObj.note_key = item.note_key;
                                                linkObj.children.push(itemObj);
                                            })
                                        })
                                        // }
    
                                    })
                                    // }
    
                                    arr.push(obj)
                                })
                            }
    
                            this.treeData[0].children = arr;
                            this.editClassModal = true;
                        } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
                 renderContent(h, {
                root,
                node,
                data
            }) {
                if (data.level == 1 || data.level == 2 || data.level == 3) {
                    return h('span', {
                        style: {
                            display: 'inline-block',
                            width: '100%'
                        }
                    }, [
                        h('span', [
                            h('Icon', {
                                props: {
                                    type: 'ios-paper-outline'
                                },
                                style: {
                                    marginRight: '8px'
                                }
                            }),
                            h('span', data.title)
                        ]),
                        h('span', {
                            style: {
                                display: 'inline-block',
                                float: 'right',
                                marginRight: '32px'
                            }
                        }, [
                            h('Button', {
                                props: Object.assign({}, this.upProps, {
                                    icon: 'arrow-up-c'
                                }),
                                style: {
                                    marginRight: '8px'
                                },
                                on: {
                                    click: () => {
                                        this.moveUp(data, 'up')
                                    }
                                }
                            }, '上移'),
                            h('Button', {
                                props: Object.assign({}, this.downProps, {
                                    icon: 'arrow-down-c'
                                }),
                                style: {
                                    marginRight: '8px'
                                },
                                on: {
                                    click: () => {
                                        this.moveUp(data, 'down')
                                    }
                                }
                            }, '下移'),
                            h('Button', {
                                props: Object.assign({}, this.appendProps, {
                                    icon: 'md-add'
                                }),
                                style: {
                                    marginRight: '8px'
                                },
                                on: {
                                    click: () => {
                                        this.append(data)
                                    }
                                }
                            }, '添加'),
                            h('Button', {
                                props: Object.assign({}, this.removeProps, {
                                    icon: 'minus-round'
                                }),
                                style: {
                                    marginRight: '8px'
                                },
                                on: {
                                    click: () => {
                                        this.remove(data)
                                    }
                                }
                            }, '删除'),
                            h('Button', {
                                props: Object.assign({}, this.appendProps, {
                                    // icon: 'md-add'
                                }),
                                style: {
                                    marginRight: '8px'
                                },
                                on: {
                                    click: () => {
                                        this.editorContent(data)
                                    }
                                }
                            }, '修改'),
                        ])
                    ]);
                } else {
                    if (data.type == 1) {
                        var content = [];
                        data.images.forEach((item, index) => {
                            content.push(h('img', {
                                attrs: {
                                    src: 'https://storage.art-kangaroo.com' + item
                                },
                                style: {
                                    width: '100px',
                                    marginRight: '10px'
                                },
                                on: {
                                    click: () => {
                                        this.lookContent(data, index)
                                    }
                                }
                            }, ))
                        })
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%'
                            }
                        }, [
                            h('div', data.title),
                            h('span', content),
                            h('span', {
                                style: {
                                    display: 'inline-block',
                                    float: 'right',
                                    marginRight: '32px'
                                }
                            }, [
    
                                h('Button', {
                                    props: Object.assign({}, this.removeProps, {
                                        icon: 'minus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove(data)
                                        }
                                    }
                                }, '删除'),
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        // icon: 'md-add'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.editorContent(data)
                                        }
                                    }
                                }, '修改'),
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        // icon: 'md-add'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.lookContent(data)
                                        }
                                    }
                                }, '查看'),
    
                            ])
                        ]);
                    } else if (data.type == 2) {
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%'
                            }
                        }, [
                            h('div', data.title),
                            h('span', [
                                h('video', {
                                    attrs: {
                                        src: 'https://storage.art-kangaroo.com' + data.source_url
                                    },
                                    style: {
                                        width: '100px',
                                        marginRight: '10px'
                                    },
                                    on: {
                                        click: () => {
                                            this.lookContent(data)
                                        }
                                    }
                                }, data.title)
                            ]),
                            h('span', {
                                style: {
                                    display: 'inline-block',
                                    float: 'right',
                                    marginRight: '32px'
                                }
                            }, [
    
                                h('Button', {
                                    props: Object.assign({}, this.removeProps, {
                                        icon: 'minus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove(data)
                                        }
                                    }
                                }, '删除'),
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        // icon: 'md-add'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.editorContent(data)
                                        }
                                    }
                                }, '修改'),
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        // icon: 'md-add'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.lookContent(data)
                                        }
                                    }
                                }, '查看'),
    
                            ])
                        ]);
                    } else if (data.type == 3) {
                        var content = [];
                        data.images.forEach((item, index) => {
                            content.push(h('img', {
                                attrs: {
                                    src: 'https://storage.art-kangaroo.com' + item,
                                },
                                style: {
                                    width: '100px',
                                    marginRight: '10px'
                                },
                                on: {
                                    click: () => {
                                        this.lookContent(data, index)
                                    }
                                }
                            }, ))
                        })
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%'
                            }
                        }, [
                            h('span', [
                                h('div', data.title),
                                h('span', content),
                            ]),
                            h('span', {
                                style: {
                                    display: 'inline-block',
                                    float: 'right',
                                    marginRight: '32px'
                                }
                            }, [
    
                                h('Button', {
                                    props: Object.assign({}, this.removeProps, {
                                        icon: 'minus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove(data)
                                        }
                                    }
                                }, '删除'),
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        // icon: 'md-add'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.editorContent(data)
                                        }
                                    }
                                }, '修改'),
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        // icon: 'md-add'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.lookContent(data)
                                        }
                                    }
                                }, '查看'),
    
                            ])
                        ]);
                    } else if (data.type == 4) {
                        var content = [];
                        data.note_key.forEach((item, index) => {
                            content.push(h('div', [
                                h('img', {
                                    attrs: {
                                        src: 'https://storage.art-kangaroo.com' + item.bg_img,
                                    },
                                    style: {
                                        width: '100px',
                                        marginRight: '10px'
                                    },
                                    // on: {
                                    //     click: () => {
                                    //         this.lookContent(data,index)
                                    //     }
                                    // }
                                }, ),
                                h('img', {
                                    attrs: {
                                        src: 'https://storage.art-kangaroo.com' + item.bt_img,
                                    },
                                    style: {
                                        width: '100px',
                                        marginRight: '10px'
                                    },
                                    // on: {
                                    //     click: () => {
                                    //         this.lookContent(data,index)
                                    //     }
                                    // }
                                }, ),
                                h('img', {
                                    attrs: {
                                        src: 'https://storage.art-kangaroo.com' + item.gif,
                                    },
                                    style: {
                                        width: '100px',
                                        marginRight: '10px'
                                    },
                                    // on: {
                                    //     click: () => {
                                    //         this.lookContent(data,index)
                                    //     }
                                    // }
                                }, ),
                                h('audio', {
                                    attrs: {
                                        src: 'https://storage.art-kangaroo.com' + item.mp3,
                                        controls: "controls"
                                    },
                                    style: {
                                        // width:'100px',
                                        marginRight: '10px'
                                    },
                                    // on: {
                                    //     click: () => {
                                    //         this.lookContent(data,index)
                                    //     }
                                    // }
                                }, ),
                            ]))
                        })
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%'
                            }
                        }, [
                            h('span', [
                                h('div', data.title),
                                h('span', content),
                            ]),
                            h('span', {
                                style: {
                                    display: 'inline-block',
                                    float: 'right',
                                    marginRight: '32px'
                                }
                            }, [
    
                                h('Button', {
                                    props: Object.assign({}, this.removeProps, {
                                        icon: 'minus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove(data)
                                        }
                                    }
                                }, '删除'),
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        // icon: 'md-add'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.editorContent(data)
                                        }
                                    }
                                }, '修改'),
                                // h('Button', {
                                //     props: Object.assign({}, this.appendProps, {
                                //         // icon: 'md-add'
                                //     }),
                                //     style: {
                                //         marginRight: '8px'
                                //     },
                                //     on: {
                                //         click: () => {
                                //             this.lookContent(data)
                                //         }
                                //     }
                                // },'查看'),
    
                            ])
                        ]);
                    } else if (data.type == 5) {
    
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%'
                            }
                        }, [
                            h('div', data.title),
                            h('span', [h('img', {
                                    attrs: {
                                        src: 'https://storage.art-kangaroo.com' + data.drawing_note.bg_img
                                    },
                                    style: {
                                        width: '100px',
                                        marginRight: '10px'
                                    },
                                    on: {
                                        click: () => {
                                            // this.lookContent(data,index)
                                        }
                                    }
                                }, ),
                                h('img', {
                                    attrs: {
                                        src: 'https://storage.art-kangaroo.com' + data.drawing_note.gif
                                    },
                                    style: {
                                        width: '100px',
                                        marginRight: '10px'
                                    },
                                    on: {
                                        click: () => {
                                            // this.lookContent(data,index)
                                        }
                                    }
                                }, )
                            ]),
                            h('span', {
                                style: {
                                    display: 'inline-block',
                                    float: 'right',
                                    marginRight: '32px'
                                }
                            }, [
    
                                h('Button', {
                                    props: Object.assign({}, this.removeProps, {
                                        icon: 'minus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove(data)
                                        }
                                    }
                                }, '删除'),
                                h('Button', {
                                    props: Object.assign({}, this.appendProps, {
                                        // icon: 'md-add'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.editorContent(data)
                                        }
                                    }
                                }, '修改'),
                                // h('Button', {
                                //     props: Object.assign({}, this.appendProps, {
                                //         // icon: 'md-add'
                                //     }),
                                //     style: {
                                //         marginRight: '8px'
                                //     },
                                //     on: {
                                //         click: () => {
                                //             this.lookContent(data)
                                //         }
                                //     }
                                // },'查看'),
    
                            ])
                        ]);
                    } else if (data.type == 6) {
                        var content = [];
                        var _this = this;
                        h('img', {
                                attrs: {
                                    src: 'https://storage.art-kangaroo.com' + data.drawing_note.bg_img
                                },
                                style: {
                                    width: '100px',
                                    marginRight: '10px'
                                },
                            }, ),
                            data.question.question_list.forEach(function(item, index) {
                                if (item.type == 1) {
                                    var imgO = '';
                                    var imgT = '';
                                    _this.materialList.forEach(function(list) {
    
                                        if (list.id == item.detail[0]) {
                                            imgO = h('img', {
                                                attrs: {
                                                    src: 'https://storage.art-kangaroo.com' + list.image_url
                                                },
                                                style: {
                                                    height: '80px',
                                                    marginRight: '10px',
                                                    padding: '10px',
                                                    verticalAlign: 'middle',
                                                    border: '1px solid #000'
                                                },
                                            }, )
                                        }
                                        if (list.id == item.detail[1]) {
                                            imgT = h('img', {
                                                attrs: {
                                                    src: 'https://storage.art-kangaroo.com' + list.image_url
                                                },
                                                style: {
                                                    height: '80px',
                                                    marginRight: '10px',
                                                    padding: '10px',
                                                    verticalAlign: 'middle',
                                                    border: '1px solid #000'
                                                },
                                            }, )
                                        }
                                    });
                                    var answerList = [];
                                    data.question.answer_material.forEach(function(list) {
                                        item.answer.forEach(function(answerItem) {
                                            if (answerItem == list.id) {
                                                answerList.push(
                                                    h('img', {
                                                        attrs: {
                                                            src: 'https://storage.art-kangaroo.com' + list.image_url
                                                        },
                                                        style: {
                                                            height: '80px',
                                                            marginRight: '10px',
                                                            padding: '10px',
                                                            verticalAlign: 'middle',
                                                            border: '1px solid #000'
                                                        },
                                                    }, )
                                                )
                                            }
    
                                        })
                                    })
                                    content.push(
                                        h('div', {
                                            style: {
                                                margin: '10px 0'
                                            }
                                        }, [
                                            h('span', '结果：'),
                                            imgO,
                                            h('span', '= 素材：'),
                                            imgT,
                                            h('span', '+ 正确答案：'),
                                            answerList
                                        ])
    
                                    )
    
                                } else if (item.type == 2) {
                                    var imgO = '';
                                    var imgT = '';
                                    var imgTh = '';
                                    _this.materialList.forEach(function(list) {
    
                                        if (list.id == item.detail[0]) {
                                            imgO = h('img', {
                                                attrs: {
                                                    src: 'https://storage.art-kangaroo.com' + list.image_url
                                                },
                                                style: {
                                                    height: '80px',
                                                    marginRight: '10px',
                                                    padding: '10px',
                                                    verticalAlign: 'middle',
                                                    border: '1px solid #000'
                                                },
                                            }, )
                                        } else if (list.id == item.detail[1]) {
                                            imgT = h('img', {
                                                attrs: {
                                                    src: 'https://storage.art-kangaroo.com' + list.image_url
                                                },
                                                style: {
                                                    height: '80px',
                                                    marginRight: '10px',
                                                    padding: '10px',
                                                    verticalAlign: 'middle',
                                                    border: '1px solid #000'
                                                },
                                            }, )
                                        } else if (list.id == item.detail[2]) {
                                            imgT = h('img', {
                                                attrs: {
                                                    src: 'https://storage.art-kangaroo.com' + list.image_url
                                                },
                                                style: {
                                                    height: '80px',
                                                    marginRight: '10px',
                                                    padding: '10px',
                                                    verticalAlign: 'middle',
                                                    border: '1px solid #000'
                                                },
                                            }, )
                                        }
                                    });
                                    var answerList = [];
                                    data.question.answer_material.forEach(function(list) {
                                        item.answer.forEach(function(answerItem) {
                                            if (answerItem == list.id) {
                                                answerList.push(
                                                    h('img', {
                                                        attrs: {
                                                            src: 'https://storage.art-kangaroo.com' + list.image_url
                                                        },
                                                        style: {
                                                            height: '80px',
                                                            marginRight: '10px',
                                                            padding: '10px',
                                                            verticalAlign: 'middle',
                                                            border: '1px solid #000'
                                                        },
                                                    }, )
                                                )
                                            }
    
                                        })
                                    })
                                    content.push(
                                        h('div', {
                                            style: {
                                                margin: '10px 0'
                                            }
                                        }, [
                                            h('span', '结果：'),
                                            imgO,
                                            h('span', '= 素材：'),
                                            imgT,
                                            h('span', '+ 素材：'),
                                            imgTh,
                                            h('span', '+ 正确答案：'),
                                            answerList
                                        ])
    
                                    )
                                } else if (item.type == 3) {
                                    var imgO = '';
                                    var imgT = '';
                                    var imgTh = '';
                                    var imgF = '';
                                    _this.materialList.forEach(function(list) {
    
                                        if (list.id == item.detail[0]) {
                                            imgO = h('img', {
                                                attrs: {
                                                    src: 'https://storage.art-kangaroo.com' + list.image_url
                                                },
                                                style: {
                                                    height: '80px',
                                                    marginRight: '10px',
                                                    padding: '10px',
                                                    verticalAlign: 'middle',
                                                    border: '1px solid #000'
                                                },
                                            }, )
                                        } else if (list.id == item.detail[1]) {
                                            imgT = h('img', {
                                                attrs: {
                                                    src: 'https://storage.art-kangaroo.com' + list.image_url
                                                },
                                                style: {
                                                    height: '80px',
                                                    marginRight: '10px',
                                                    padding: '10px',
                                                    verticalAlign: 'middle',
                                                    border: '1px solid #000'
                                                },
                                            }, )
                                        }
                                        if (list.id == item.detail[2]) {
                                            imgT = h('img', {
                                                attrs: {
                                                    src: 'https://storage.art-kangaroo.com' + list.image_url
                                                },
                                                style: {
                                                    height: '80px',
                                                    marginRight: '10px',
                                                    padding: '10px',
                                                    verticalAlign: 'middle',
                                                    border: '1px solid #000'
                                                },
                                            }, )
                                        }
                                        if (list.id == item.detail[4]) {
                                            imgF = h('img', {
                                                attrs: {
                                                    src: 'https://storage.art-kangaroo.com' + list.image_url
                                                },
                                                style: {
                                                    height: '80px',
                                                    marginRight: '10px',
                                                    padding: '10px',
                                                    verticalAlign: 'middle',
                                                    border: '1px solid #000'
                                                },
                                            }, )
                                        }
                                    });
                                    var answerList = [];
                                    data.question.answer_material.forEach(function(list) {
                                        item.answer.forEach(function(answerItem) {
                                            if (answerItem == list.id) {
                                                answerList.push(
                                                    h('img', {
                                                        attrs: {
                                                            src: 'https://storage.art-kangaroo.com' + list.image_url
                                                        },
                                                        style: {
                                                            height: '80px',
                                                            marginRight: '10px',
                                                            padding: '10px',
                                                            verticalAlign: 'middle',
                                                            border: '1px solid #000'
                                                        },
                                                    }, )
                                                )
                                            }
    
                                        })
                                    })
                                    content.push(
                                        h('div', {
                                            style: {
                                                margin: '10px 0'
                                            }
                                        }, [
                                            h('span', '结果：'),
                                            imgO,
                                            h('span', '= 素材：'),
                                            imgT,
                                            h('span', '+ 素材：'),
                                            imgTh,
                                            h('span', '+ 正确答案：'),
                                            answerList,
                                            h('span', '+ 素材：'),
                                            imgF,
                                        ])
                                    )
                                }
    
                            })
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%'
                            }
                        }, [
                            h('div', data.title),
                            h('div', content),
                            h('span', {
                                style: {
                                    display: 'inline-block',
                                    float: 'right',
                                    marginRight: '32px'
                                }
                            }, [
    
                                h('Button', {
                                    props: Object.assign({}, this.removeProps, {
                                        icon: 'minus-round'
                                    }),
                                    style: {
                                        marginRight: '8px'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove(data)
                                        }
                                    }
                                }, '删除'),
                                // h('Button', {
                                //     props: Object.assign({}, this.appendProps, {
                                //         // icon: 'md-add'
                                //     }),
                                //     style: {
                                //         marginRight: '8px'
                                //     },
                                //     on: {
                                //         click: () => {
                                //             this.editorContent(data)
                                //         }
                                //     }
                                // },'修改'),
                            ])
                        ]);
                    }
                }
            },
             // 排序上下移
            moveUp(record, move,node,q) {
                this.lessonId=record.lesson_id
                setSort({
                    chapter_id: record.chapter_id,
                    move: move,

                }).then(res => {
                    res=res.data;
                        if (res.code == 200) {
                            if (move == 'up') {
                                this.setUp(record)
                            } else {
                                this.setDown(record)
                            }
                            this.chapterFrom.lesson_id = this.lessonId;
                            this.lessonId = this.lessonId;
    
                            this.$Message.success('修改成功');

                        } else if (res.code == 14004) {
                            this.$store.commit('logout', this);
                            this.$store.commit('clearOpenedSubmenu');
                            this.$router.push({
                                name: 'login'
                            });
                            this.$Message.error(res.msg);
                        } else {
                            this.$Message.error(res.msg);
                        }
                    })
            },
             // 上移
            setUp(record) {

                this.treeData[0].children.forEach((item, i) => {
                    if (item.chapter_id == record.chapter_id) {
                        if (i != 0) {
                            this.treeData[0].children[i] = this.treeData[0].children.splice(i - 1, 1, this.treeData[0].children[i])[0];
                        }
                    } else {
                        item.children.forEach((list, j) => {
                            if (list.chapter_id == record.chapter_id) {
                                if (j != 0) {
                                    item.children[j] = item.children.splice(j - 1, 1, item.children[j])[0];
                                }
                            } else {
                                list.children.forEach((block, index) => {
                                    if (block.chapter_id == record.chapter_id) {
                                        if (index != 0) {
                                            list.children[index] = list.children.splice(index - 1, 1, list.children[index])[0];
                                        }
                                    } else {
                                        block.children.forEach((content, sub) => {
                                            if (content.chapter_id == record.chapter_id) {
                                                content.children[sub] = content.children.splice(sub - 1, 1, content.children[sub])[0];
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }
                })
    
            },
            // 下移
            setDown(record) {

                var changeArr=[];
                var index='';
                this.treeData[0].children.forEach((item, i) => {
                    if (item.chapter_id == record.chapter_id) {
                        if (i != this.treeData[0].children.length - 1) {
                            index=i;
                            changeArr=this.treeData[0].children
                            // this.treeData[0].children[i] = this.treeData[0].children.splice(i + 1, 1, this.treeData[0].children[i])[0];
                        }
                    } else {
                        item.children.forEach((list, j) => {
                            if (list.chapter_id == record.chapter_id) {
                                if (j != item.children.length - 1) {
                                    index=j;
                                    changeArr=item.children;
                                    // item.children[j] = item.children.splice(j + 1, 1, item.children[j])[0];
                                }
                            } else {
                                list.children.forEach((block, inde) => {
                                    if (block.chapter_id == record.chapter_id) {
                                        if (inde != list.children.length - 1) {
                                            index=inde;
                                            changeArr=list.children;
                                            // list.children[index] = list.children.splice(index + 1, 1, list.children[index])[0];
                                        }
                                    } else {
                                        block.children.forEach((content, sub) => {
                                            if (content.chapter_id == record.chapter_id) {
                                                index=sub;
                                                changeArr=content.children;
                                                    // content.children[sub] = content.children.splice(sub + 1, 1, content.children[sub])[0];
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }
                })
                changeArr[index]=changeArr.splice(index + 1, 1, changeArr[index])[0];
            },
             // 修改课程章节
            editorContent(data) {
              
                this.modelLabel='修改';
                this.editorData=data;
                this.appendData=data;

                if (data.level == 4) {
                    this.chapterLevel = true;
                } else {
                    this.chapterLevel = false;
                }

                this.chapterFrom.chapter_id = data.chapter_id;
                this.chapterFrom.parent_id = data.parent_id;
                this.chapterFrom.directory_type = data.directory_type;
                if (data.title) {
                    this.chapterFrom.name = data.title
                } else {
                    this.chapterFrom.name = ''
                }
                if (data.level == 4) {
                    if (data.type == 3 || data.type == 1) {
    
                        this.chapterFrom.images = data.images;
                    } else {
                        this.chapterFrom.images = [];
                    }
                    this.chapterFrom.type = data.type;
                    if (data.type == 2 || data.type == 3) {
                        this.chapterFrom.source_url = data.source_url;
                    } else {
                        this.chapterFrom.source_url = '';
                    }
                    this.chapterFrom.drawing_note = data.drawing_note;
                    this.chapterFrom.note_key = data.note_key;
                    if (data.type == 6) {
                        this.chapterFrom.question = data.question;
                        this.questionList = data.question.answer_material;
    
                    }
    
                } else {
                    this.chapterFrom.source_url = '';
                    this.chapterFrom.images = [];
                    this.chapterFrom.type = '';
                    this.chapterFrom.drawing_note = {
                        'bg_img': '',
                        'gif': ''
                    };
                    this.chapterFrom.note_key = [];
    
                }
                this.classModel = true;
            },
            // 保存章节
            okChapter(){
                if (!this.chapterLevel) {
                    if (this.chapterFrom.name == '') {
                        this.$Message.error('请填写章节名');
                        return;
                    }
                } else {
                    if (this.chapterFrom.type == '') {
                        this.$Message.error('请选择章节类型');
                        return;
                    } else {
                        if (this.chapterFrom.type == 1) {
                            if (this.chapterFrom.images.length == 0) {
                                this.$Message.error('请上传图片');
                                return;
    
                            }
                        } else if (this.chapterFrom.type == 2) {
                            if (this.chapterFrom.source_url == '') {
                                this.$Message.error('请上传视频');
                                return;
                            }
                        } else if (this.chapterFrom.type == 3) {
                            if (this.chapterFrom.images.length == 0) {
                                this.$Message.error('请上传图片');
                                return;
                            } else if (this.chapterFrom.source_url == '') {
                                this.$Message.error('请上传音频');
                                return;
                            }
                        } else if (this.chapterFrom.type == 4) {
                            if (this.chapterFrom.note_key.length == 0) {
                                this.$Message.error('请上传一组音符识键');
                                return;
                            }
                        } else if (this.chapterFrom.type == 6) {
                            if (this.chapterFrom.question.background == '') {
                                this.$Message.error('请上传背景图');
                                return;
                            }
                        }
                    }
                }
                if (this.chapterFrom.chapter_id != '') {
                    
                    modifySave({
                            chapter_id: this.chapterFrom.chapter_id,
                            lesson_id: this.chapterFrom.lesson_id,
                            name: this.chapterFrom.name,
                            directory_type: this.chapterFrom.directory_type,
                            parent_id: this.chapterFrom.parent_id,
                            type: this.chapterFrom.type,
                            images: this.chapterFrom.images,
                            source_url: this.chapterFrom.source_url,
                            note_key: this.chapterFrom.note_key,
                            drawing_note: this.chapterFrom.drawing_note,
                            question: this.chapterFrom.question,
                            member_type: 2

                    }).then(responese => {
                        responese=responese.data;
                            if (responese.code == 200) {
                                this.treeData[0].children.forEach((item, i) => {
                                        if (item.chapter_id == this.editorData.chapter_id) {
                                           
                                           item.title=responese.data[i].name;
                                            item.directory_type=responese.data[i].directory_type


                                        } else {
                                            item.children.forEach((list, j) => {
                                               

                                                if (list.chapter_id ==  this.editorData.chapter_id) {
                                                   list.title=responese.data[i].children[j].name;
                                                } else {
                                                    list.children.forEach((block, index) => {
                                                        if (block.chapter_id ==  this.editorData.chapter_id) {
                                                           block.title=responese.data[i].children[j].children[index].name;
                                                          
                                                        } else {
                                                            block.children.forEach((content, sub) => {
                                                                if(content.chapter_id ==  this.editorData.chapter_id){
                                                                    content.drawing_note=responese.data[i].children[j].children[index].children[sub].drawing_note;
                                                                    content.images=responese.data[i].children[j].children[index].children[sub].images;
                                                                    content.note_key=responese.data[i].children[j].children[index].children[sub].note_key;
                                                                    content.question=responese.data[i].children[j].children[index].children[sub].question;
                                                                    content.source_url=responese.data[i].children[j].children[index].children[sub].source_url;
                                                                    content.type=responese.data[i].children[j].children[index].children[sub].type;
                                                                    if(content.type==1){
                                                                        content.title="图片类："
                                                                    }else if(content.type==2){
                                                                        content.title="视频类："
                                                                    }else if(content.type==3){
                                                                        content.title="组图+音频类："
                                                                    }else if(content.type==4){
                                                                        content.title="音符识键："
                                                                    }else if(content.type==5){
                                                                        content.title="画音符："
                                                                    }else if(content.type==6){
                                                                        content.title="测试题："
                                                                    }
                                                                }
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                                this.classModel = false;
                                this.chapterFrom.lesson_id = this.lessonId;
                                this.lessonId = this.lessonId;
                            } else if (responese.code == 14004) {
                                this.$store.commit('logout', this);
                                this.$store.commit('clearOpenedSubmenu');
                                this.$router.push({
                                    name: 'login'
                                });
                                this.$Message.error(responese.msg);
                            } else {
                                this.$Message.error(responese.msg);
                            }
                        })
                } else {
                     addSave({
                            lesson_id: this.chapterFrom.lesson_id,
                            name: this.chapterFrom.name,
                            directory_type: this.chapterFrom.directory_type,

                            parent_id: this.chapterFrom.parent_id,
                            type: this.chapterFrom.type,
                            images: this.chapterFrom.images,
                            source_url: this.chapterFrom.source_url,
                            note_key: this.chapterFrom.note_key,
                            drawing_note: this.chapterFrom.drawing_note,
                            question: this.chapterFrom.question,
                            // member_type: 2

                    }).then(responese => {
                        responese=responese.data;
                            if (responese.code == 200) {
                                if(this.appendData.chapter_id==0){
                                    var objData=responese.data[responese.data.length-1]
                                    var obj={   
                                        chapter_id:objData.chapter_id,
                                        children:objData.children,
                                        lesson_id:objData.lesson_id,
                                        level:objData.level,
                                        parent_id:objData.parent_id,
                                        title:objData.name,
                                        directory_type:objData.directory_type
                                    };
                                    
                                    this.treeData[0].children.push(obj)
                                }else{
                                    this.treeData[0].children.forEach((item, i) => {
                                      
                                        if (item.chapter_id == this.appendData.chapter_id) {
                                            var objData=responese.data[i].children[responese.data[i].children.length-1]
                                            var obj={
                                                chapter_id:objData.chapter_id,
                                                children:objData.children,
                                                lesson_id:objData.lesson_id,
                                                level:objData.level,
                                                parent_id:objData.parent_id,
                                                title:objData.name
                                            };
                                            this.treeData[0].children[i].children.push(obj)
                                        } else {
                                            item.children.forEach((list, j) => {
                                                if (list.chapter_id == this.appendData.chapter_id) {
                                                    var objData=responese.data[i].children[j].children[responese.data[i].children[j].children.length-1];
                                                    var obj={
                                                        chapter_id:objData.chapter_id,
                                                        children:objData.children,
                                                        lesson_id:objData.lesson_id,
                                                        level:objData.level,
                                                        parent_id:objData.parent_id,
                                                        title:objData.name
                                                    };
                                                    this.treeData[0].children[i].children[j].children.push(obj)
                                                } else {
                                                    list.children.forEach((block, index) => {
                                                        if (block.chapter_id == this.appendData.chapter_id) {
                                                            var objData=responese.data[i].children[j].children[index].children[responese.data[i].children[j].children[index].children.length-1];
                                                            var title='';

                                                            if(objData.type==1){
                                                                title='图片类：'
                                                            }else if(objData.type==2){
                                                                title='视频类：'

                                                            }else if(objData.type==3){
                                                                title='组图+音频类：'

                                                            }else if(objData.type==4){
                                                                title='音符识键：'

                                                            }else if(objData.type==5){
                                                                title='画音符：'

                                                            }else{
                                                                title='测试题：'
                                                            }
                                                            var obj={
                                                                chapter_id:objData.chapter_id,
                                                                drawing_note:objData.drawing_note,
                                                                images:objData.images,
                                                                level:objData.level,
                                                                lesson_id:objData.lesson_id,
                                                                note_key:objData.note_key,
                                                                question:objData.question,
                                                                parent_id:objData.parent_id,
                                                                source_url:objData.source_url,
                                                                type:objData.type,
                                                                title:title
                                                            };
                                                            this.treeData[0].children[i].children[j].children[index].children.push(obj);
                                                            
                                                        } else {
                                                            
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                                this.classModel = false;
    
                            } else if (responese.code == 14004) {
                                this.$store.commit('logout', this);
                                this.$store.commit('clearOpenedSubmenu');
                                this.$router.push({
                                    name: 'login'
                                });
                                this.$Message.error(responese.msg);
                            } else {
                                this.$Message.error(responese.msg);
                            }
                        })
                }
            },
            getDirectory(){
                 fetchDirectory({}).then(res => {
                    res = res.data;

                        if (res.code == 200) {
                            this.directoryList=res.data;
    
                        } else if (res.code == 14004) {
                            this.$store.commit('logout', this);
                            this.$store.commit('clearOpenedSubmenu');
                            this.$router.push({
                                name: 'login'
                            });
                            this.$Message.error(res.msg);
                        } else {
                            this.$Message.error(res.msg);
                        }
                    })
            },
            changeTree(arr){
                this.chapter_id_arr=[];
                arr.forEach((item)=>{
                    this.chapter_id_arr.push(item.chapter_id);
                })
            },
             // 删除章节
            remove(data){
                this.lessonId = data.lesson_id;
                this.chapter_id=data.chapter_id;
                this.remindContent= '确认删除该章节吗？';//提醒内容
                this.remindModal=true; //提醒弹
            },
            //提醒弹出层的确定事件
            primaryRemind() {
                setDel({
                    chapter_id: this.chapter_id,
                    member_type:2,
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        var chapter_id=this.chapter_id;
                        this.treeData[0].children.forEach((item, i) => {
                                        if (item.chapter_id == chapter_id) {
                                            this.treeData[0].children.splice(i, 1)
                                        } else {
                                            item.children.forEach((list, j) => {
                                                if (list.chapter_id == chapter_id) {
                                                    item.children.splice(j, 1)
                                                } else {
                                                    list.children.forEach((block, index) => {
                                                        if (block.chapter_id == chapter_id) {
                                                            list.children.splice(index, 1)
                                                          
                                                        } else {
                                                            block.children.forEach((content, sub) => {
                                                                if(content.chapter_id == chapter_id){
                                                                    block.children.splice(sub, 1)
                                                                }
                                                            })
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                        this.chapterFrom.lesson_id = this.lessonId;
                        this.lessonId = this.lessonId;
                        this.remindModal = false;
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            getChapterImgList(picList) {
                var arr = [];
                for (var i = 0; i < picList.length; i++) {
                    arr.push(picList[i].url.split('.com')[1])
                }
              
                this.chapterFrom.images = arr;
            },
            getBg(list) {
                this.chapterFrom.question.background = '/image/' + list[0].name
            },
            getBgImg(picList){
                this.chapterFrom.drawing_note.bg_img = picList[0].url.split('.com')[1]
            },
            // 上传答案素材
            getQuestionList(list) {
                var arr = [];
                for (var i = 0; i < list.length; i++) {
                    arr.push('/image/' + list[i].name);
                }
                this.questionImg = arr;
    
            },
            getVideos(list) {
                this.chapterFrom.source_url = list[0].url.split('.com')[1]
            },
            getAudioList(list){
                this.chapterFrom.source_url = list[0].url
            },
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            changEndtime(time) {
    
                if (time == '') {
                    this.formItem.end_time = '';
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 取消关闭弹层
            cancel() {
                this.editClassModal = false;
            },
             // 课程内容弹层取消
            cancelLessonContent() {
                this.lessonContentModel = false;
            },
            // 取消保存章节
            cancelChapter() {
                this.classModel = false;
            },
            // 关闭提醒弹出
            cancelRemain() {
                this.remindModal = false;
            },
            //搜索框搜索
            handleSearch() {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage(row) {
                this.formItem.page = row;
                this.getData();
            },
    
        },
        created() {
            this.getData();
            this.getLessonTypeList();
            this.getDirectory();
            this.getMaterialList();


        }
    };
</script>
